import { createSelector } from 'reselect';

export const applicationSelector = (state) => state.agreement;

export const selectAgreement = createSelector(
  applicationSelector,
  (state) => state.Agreement,
);

export const selectPDFAgreement = createSelector(
  applicationSelector,
  (state) => state.PDFAgreement,
);
